package com.neurobs.ccabserver.administrator.controller

import com.neurobs.ccab.IdentityData
import com.neurobs.ccabserver.translation.Main
import com.neurobs.js.controller.AdminPanelController
import com.neurobs.js.dom.ElementFactory.PanelView
import com.neurobs.js.dom.DOMViewElement._
import com.neurobs.js.view.{Container, Gui}
import scalatags.JsDom.all._
import com.neurobs.js.dom.ElementFactory
import com.neurobs.util.Guid
import org.scalajs.dom.raw.Event


class TranslationToolController(gui: Gui, userData: IdentityData) extends AdminPanelController {

	private val reactDiv = div().render

  private val panel: PanelView = {
    val panelStyles = Seq(("background-color", "transparent"), ("color", "white"), ("border-style", "solid"), ("border-color", "white"))
    val temp = new PanelView(title = "Translation", showRefresh = false, fullWidth = true,
      styles = Some(panelStyles)
    )
    val closeButton = ElementFactory.makeLink(text = "Close")
    closeButton.onclick =  (_:Event) => delegate.foreach(_.close())
    temp.setRightCorner(closeButton)
    temp.container.addChild(reactDiv)
    temp
  }

  override def didAppear(): Unit = {
    new Main(reactDiv, userData)
  }

  override def container: Container = {
    panel.container
  }

}
